export const MAX_VISIBLE_MERCHANTS = 8;
